<div id="modal-content-wrapper">
  <div class="modal-header justify-content-center">
    <h4 class="title text-center">Show / Hide Columns</h4>
  </div>
  <div class="modal-body">
    <div *ngFor="let c of columnTitles">
      <div *ngIf="columns[c.key] != null">
        <input type="checkbox" [id]="'checkbox-' + c.key" [(ngModel)]="columns[c.key]" class="checkbox-inline align-middle" />
        <label [for]="'checkbox-' + c.key">{{ c.title }}</label>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="modal.dismiss('cancel')">
      <fa-icon [icon]="['fal','check']"></fa-icon>
    </button>
  </div>
</div>
